<div class="tile body round link with-ident" style="margin-top: 30px" [class]="(selectMode())?((nextContractLevel()==1)?'on':'off'):''" (click)="switchMode(1);">
    @if (!selectMode()) {
    <button class="top-header" [class]="(step()==1)?'highlighted-onetime':''" style="animation-delay: 2s;">Short-Term Savings</button>
    }
    @if (selectMode()) {
    <button class="top-header">
        Short-Term Savings
        <div class="toggle" [class]="(nextContractLevel()==1)?'selected':''" style="float: right; height: 30px; width: 50px; border-color: #ccc; margin-top: -1px;">
            <span class="handle" style="height: 28px; width: 28px;"></span>
        </div>
    </button>
    }
    <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
        <div class="d-flex">
            <div class="tile-bolt">1</div>
            <div class="auto" #area>
                <div class="auto-renewal">
                    Captures maximum savings yield up to 9 months into the future. Triggers during <span class="low">Low</span>,
                    <span class="average">Avg</span>, <span class="high">High</span> markets
                </div>
            </div>
            <div>
                <svg height="50" width="50" viewBox="0 0 50 50">
                    <path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" class="price-icon high"></path>
                    <path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" transform="translate(0,12)" class="price-icon average"></path>
                    <path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" transform="translate(0,24)" class="price-icon low"></path>
                </svg>
            </div>
        </div>
    </div>
    <div class="bottom-tag">
        1-9 Month Rates
    </div>
</div>

<div class="consumption-info mt-20" *ngIf="!hasConsumption()">
    Nonstop Shop ai Levels 2 and 3 require <a class="link" (click)="openConsumptionDialog()">12 months of consumption history</a> to properly weight the cost benefit of our price plans. If 12 months of consumption history is not available, you can select Nonstop Shop ai Level 1.
</div>

@if (!previewMode()) {
<div class="tile body round with-ident"
     [style]="(hasConsumption())?'margin-top: 50px':'margin-top: 30px'" [class]="((selectMode())?((nextContractLevel()==2)?'on':'off'):'')+((hasConsumption())?' link':' disabled')" (click)="switchMode(2);">
    @if (!selectMode()) {
    <button class="top-header" [class]="(step()==1)?'highlighted-onetime':''" style="animation-delay: 4s;">Mid-Term Savings</button>
    }
    @if (selectMode()) {
    <button class="top-header">
        Mid-Term Savings
        <div class="toggle" [class]="(nextContractLevel()==2)?'selected':''" style="float: right; height: 30px; width: 50px; border-color: #ccc; margin-top: -1px;">
            <span class="handle" style="height: 28px; width: 28px;"></span>
        </div>
    </button>
    }
    <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
        <div class="d-flex">
            <div class="tile-bolt">2</div>
            <div class="auto" #area>
                <div class="auto-renewal">
                    Captures maximum savings yield up to 18 months into the future. Triggers during <span class="low">Low</span> and <span class="average">Avg</span> markets.
                </div>
            </div>
            <div>
                <svg height="50" width="50" viewBox="0 0 50 50">
                    <path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" transform="translate(0,6)" class="price-icon average"></path>
                    <path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" transform="translate(0,18)" class="price-icon low"></path>
                </svg>
            </div>
        </div>
    </div>
    <div class="bottom-tag">
        1-18 Month Rates
    </div>
</div>
}

@if (!previewMode()) {
<div class="tile body round link with-ident"
     style="margin-top: 50px" [class]="((selectMode())?((nextContractLevel()==3)?'on':'off'):'')+((hasConsumption())?' link':' disabled')" (click)="switchMode(3);">
    @if (!selectMode()) {
    <button class="top-header" [class]="(step()==1)?'highlighted-onetime':''" style="animation-delay: 6s;">Long-Term Savings</button>
    }
    @if (selectMode()) {
    <button class="top-header">
        Long-Term Savings
        <div class="toggle" [class]="(nextContractLevel()==3)?'selected':''" style="float: right; height: 30px; width: 50px; border-color: #ccc; margin-top: -1px;">
            <span class="handle" style="height: 28px; width: 28px;"></span>
        </div>
    </button>
    }
    <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
        <div class="d-flex">
            <div class="tile-bolt">3</div>
            <div class="auto" #area>
                <div class="auto-renewal">
                    Captures maximum savings yield up to 36 months into the future. Triggers during <span class="low">Low</span> markets.
                </div>
            </div>
            <div>
                <svg height="50" width="50" viewBox="0 0 50 50">
                    <path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" transform="translate(0,12)" class="price-icon low"></path>
                </svg>
            </div>
        </div>
    </div>
    <div class="bottom-tag">
        1-36 Month Rates
    </div>
</div>
}